export const ACTIVIITY_LIST = [
  'basketball',
  'boots',
  'cleats',
  'lifestyle',
  'running',
  'sandals',
  'skateboarding',
];
